module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/image-placeholder-de52d5c666d042ac3a0aa305c78ee6cd.svg";